// @core/api/endpoints/project/resolve_item_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Resolve item key
 * Resolves a human-readable item key (e.g., MP-123) to a ProjectItem across all accessible projects. Used by WorkflowService for git commit parsing and global search.
 */
export async function ResolveItemKey(
  item_key: string,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/items/resolve/:item_key`;
  requestPath = requestPath.replace(':item_key', encodeURIComponent(item_key));
  const requestOptions = options;
  return client.get<ItemResponse>(requestPath, { ...requestOptions });
}
